/** Linguistic direction for GSAP x offsets. Physical geometry stays unsigned. */
export function dirMul(): number {
  if (typeof document === "undefined") return 1;
  return document.documentElement.dir === "rtl" ? -1 : 1;
}

export function isRtl(): boolean {
  if (typeof document === "undefined") return false;
  return document.documentElement.dir === "rtl";
}
